import React from "react";
import { Card } from "antd";
import Num from "./Num";

const TONES = {
  default: undefined,
  danger: "#9E2F2F",
  warning: "#96601A",
  success: "#2F6B33",
};

/**
 * Rij met kerncijfers boven een overzicht (openstaand / betaald / totaal / …).
 *
 * `items`: [{ label, value, hint, tone }] waarbij tone het bedrag kleurt —
 * openstaande bedragen rood, niet-verrekende aanbetalingen oranje.
 */
const StatCards = ({ items = [], minWidth = 200, style }) => {
  if (!items.length) return null;
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(auto-fit, minmax(${minWidth}px, 1fr))`,
        gap: 12,
        marginBottom: 20,
        ...style,
      }}
    >
      {items.map((item) => (
        <Card key={item.label} size="small" styles={{ body: { padding: "14px 16px" } }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <span style={{ fontSize: 12.5, color: "rgba(0, 0, 0, 0.55)" }}>{item.label}</span>
            <Num size={21} strong style={{ color: TONES[item.tone] }}>
              {item.value}
            </Num>
            {item.hint ? <span style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.4)" }}>{item.hint}</span> : null}
          </div>
        </Card>
      ))}
    </div>
  );
};

export default StatCards;
